namespace Nobox {
    @Serenity.Decorators.registerEditor('Serenity.CustomRecaptcha', [Serenity.IStringValue])
    @Serenity.Decorators.element("<div/>")
    export class CustomRecaptcha extends Serenity.Widget<Serenity.RecaptchaOptions> implements Serenity.IStringValue {
        constructor(div: JQuery, opt: Serenity.RecaptchaOptions) {
            super(div, opt);
            function getCookie(name) {
                const value = `; ${document.cookie}`;
                const parts = value.split(`; ${name}=`);

                if (parts[1] == undefined) {
                    return "cosmos-dark";
                } else {
                    return parts[1].split(';').shift();
                }
            }
            var theme = getCookie("ProThemeSelection");
            $(document).ready(function () {
                var width = $('.g-recaptcha').parent().width();
                if (width < 302) {
                    var scale = width / 302;
                    $('.g-recaptcha').css('transform', 'scale(' + scale + ')');
                    $('.g-recaptcha').css('-webkit-transform', 'scale(' + scale + ')');
                    $('.g-recaptcha').css('transform-origin', '0 0');
                    $('.g-recaptcha').css('-webkit-transform-origin', '0 0');
                }
            }); 
            if (theme == "cosmos-dark") {
                this.element.addClass('g-recaptcha').attr('data-theme', "dark");
            } else {
                this.element.addClass('g-recaptcha').attr('data-theme', "light");
            }
            this.element.addClass('g-recaptcha').attr('data-sitekey', this.options.siteKey);
            this.element.addClass('g-recaptcha').attr('style', "transform: scale(0.9); -webkit-transform: scale(0.9);");
            this.element.height(80);
            this.element.width(290);
            this.element.css("max-width","304px");
            this.element.css("text-align","left");
            this.element.css("margin", "auto");
            this.element.on('DOMNodeInserted', () => {
                this.element.find("iframe").attr("width", "302");
                this.element.find("iframe").attr("height", "75");
            })
            if (!!(window['grecaptcha'] == null && $('script#RecaptchaInclude').length === 0)) {
                var src = 'https://www.google.com/recaptcha/api.js';
                var lng = this.options.language;
                if (lng == null) {
                    lng = $('html').attr('lang') ?? '';
                }
                src += '?hl=' + lng;
                $('<script/>').attr('id', 'RecaptchaInclude').attr('src', src).appendTo(document.body);
            }

            var valInput = $('<input />').insertBefore(this.element)
                .attr('id', this.uniqueName + '_validate').val('x');

            var gro = {};
            gro['visibility'] = 'hidden';
            gro['width'] = '0px';
            gro['height'] = '0px';
            gro['padding'] = '0px';

            var input = valInput.css(gro);
            var self = this;

            Q.addValidationRule(input, this.uniqueName, e => {
                if (Q.isEmptyOrNull(this.get_value())) {
                    return Q.text('Validation.Required');
                }
                return null;
            });
        }

        get_value(): string {
            return this.element.find('.g-recaptcha-response').val();
        }

        set_value(value: string): void {
            // ignore
        }
    }
}